var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluetik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63661 1.64099C7.34537 0.787914 8.65463 0.787915 9.36339 1.64099V1.64099C9.77203 2.13283 10.4139 2.36645 11.0431 2.25234V2.25234C12.1344 2.05444 13.1373 2.89601 13.1319 4.00508V4.00508C13.1288 4.64452 13.4703 5.23607 14.0257 5.55309V5.55309C14.9888 6.10295 15.2162 7.39232 14.4992 8.23845V8.23845C14.0857 8.72628 13.9671 9.39897 14.1888 9.99878V9.99878C14.5732 11.0391 13.9185 12.173 12.8254 12.3602V12.3602C12.1951 12.4682 11.6719 12.9073 11.4561 13.5092V13.5092C11.0818 14.5532 9.85153 15.001 8.89374 14.4418V14.4418C8.34153 14.1194 7.65847 14.1194 7.10626 14.4418V14.4418C6.14847 15.001 4.91817 14.5532 4.54392 13.5092V13.5092C4.32815 12.9073 3.80489 12.4682 3.17463 12.3602V12.3602C2.08146 12.173 1.42684 11.0391 1.81124 9.99878V9.99878C2.03287 9.39897 1.91425 8.72628 1.50085 8.23845V8.23845C0.783808 7.39232 1.01116 6.10295 1.97435 5.55309V5.55309C2.52967 5.23607 2.8712 4.64452 2.86809 4.00508V4.00508C2.86269 2.89601 3.86563 2.05444 4.95692 2.25234V2.25234C5.58611 2.36645 6.22797 2.13283 6.63661 1.64099V1.64099Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.13333L7.1 10L11 6",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetik);
export default __webpack_public_path__ + "static/media/bluetik.84e69d9b443be77d54e0a47d8322c7e2.svg";
export { ForwardRef as ReactComponent };